<template>
    <div>
        <div v-if="codes.length > 1 || filterBadges.applied.length || filterBadges.ignored.length"
            class="d-flex align-center flex-wrap">
            <FilterBadges :badges="filterBadges"></FilterBadges>
            <v-spacer></v-spacer>
            <CurrencyToggle v-model="selected" :codes="codes"></CurrencyToggle>
        </div>
        <v-row dense class="mt-1">
            <v-col v-for="kpi in kpis" :key="kpi.title" cols="12" sm="4">
                <StatCard :tone="kpi.tone" :icon="kpi.icon" :title="kpi.title" :value="kpi.value"
                    :description="kpi.description" :loading="loading"></StatCard>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12" md="7">
                <ChartPanel title="Compras por día" type="line" :labels="porDia.labels" :data="porDia.data"
                    :options="options.vertical" :loading="loading" :error="error"></ChartPanel>
            </v-col>
            <v-col cols="12" md="5">
                <ChartPanel title="Top proveedores" type="horizontalBar" :labels="proveedores.labels"
                    :data="proveedores.data" :options="options.horizontal" :loading="loading" :error="error">
                </ChartPanel>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import StatCard from '@/components/shared/StatCard.vue';
import DashboardDataService from '@/service/dashboard/DashboardDataService';
import { dashboardFilterMixin, dashboardRangeMixin, dashboardWidgetMixin } from '@/mixins/dashboardWidgetMixin';
import ChartPanel from './ChartPanel.vue';
import CurrencyToggle from './CurrencyToggle.vue';
import FilterBadges from './FilterBadges.vue';
import { chartFor, currencyCodes, dayChartFor, formatMoney, moneyChartOptions, pickCurrency, summaryFor } from './dashboardData';

/**
 * Compras del periodo (entradas de tipo compra, `api/v1/dashboard/compras`): total comprado, lo que aún se debe de
 * esas compras, y desglose por día y proveedor. Por moneda, igual que las ventas.
 */
export default {
    name: 'GraficaCompras',
    components: { ChartPanel, CurrencyToggle, FilterBadges, StatCard },
    mixins: [dashboardWidgetMixin, dashboardRangeMixin, dashboardFilterMixin],
    // El producto no se aplica: el importe de una compra se guarda por entrada y no está confirmado que la suma de sus
    // líneas (finalImport) coincida con el total final (finalTotal).
    filterScope: {
        sucursal: true,
        producto: false,
        reasons: { producto: 'Las compras se registran por entrada: el importe no se divide por producto.' }
    },
    data() {
        return { data: null, selected: '' };
    },
    computed: {
        resumen() {
            return this.data ? this.data.resumen : [];
        },
        codes() {
            return currencyCodes(this.resumen);
        },
        currency() {
            return pickCurrency(this.codes, this.selected);
        },
        summary() {
            return summaryFor(this.resumen, this.currency);
        },
        options() {
            return moneyChartOptions(this.currency);
        },
        porDia() {
            return dayChartFor(this.data && this.data.porDia, this.currency, this.week);
        },
        proveedores() {
            return chartFor(this.data && this.data.topProveedores, this.currency);
        },
        kpis() {
            const show = (value) => (this.error ? null : formatMoney(value, this.currency));
            return [
                { title: 'Compras del periodo', value: show(this.summary.total), tone: 'info', icon: 'fas fa-cart-shopping', description: this.error ? '' : `${this.summary.tickets} entradas` },
                { title: 'Pendiente de pago', value: show(this.summary.owed), tone: 'warning', icon: 'fas fa-file-invoice-dollar', description: 'De las compras del periodo' },
                { title: 'Compra promedio', value: show(this.summary.average), tone: 'neutral', icon: 'fas fa-receipt', description: '' }
            ];
        }
    },
    created() {
        this.reload();
    },
    methods: {
        reload() {
            return this.loadWidget(() => DashboardDataService.compras(this.startNatural, this.endNatural, this.filters), (data) => {
                this.data = data;
            });
        }
    }
};
</script>
